import { Icon, IconSize, IconType } from '../../Icon';
import * as React from 'react';
import { rightChevron } from '../../../../utilities/order/magicStrings';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

export const MenuItemContent: FCWithChildren = ({ children }) => (
  <>
    <Icon type={IconType.Plus} size={IconSize.Small} />
    {children}
    {` ${rightChevron}`}
  </>
);
